export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";